import { MediaLayer } from "./MediaLayer";
import type { MediaTextSplitData } from "./schemas";

export default function MediaTextSplit(props: MediaTextSplitData) {
  const mediaSide = props.side ?? "left";
  return (
    <section className="relative w-full bg-background py-12 md:py-16 px-6 md:px-10">
      <div
        className={`max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center ${
          mediaSide === "right" ? "md:[&>*:first-child]:order-2" : ""
        }`}
      >
        <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-muted">
          <MediaLayer media={props.media} alt={props.title || "media"} />
        </div>
        <div>
          {props.kicker && (
            <div className="text-[10px] tracking-[0.35em] uppercase text-gold/85 mb-4">
              {props.kicker}
            </div>
          )}
          {props.title && (
            <h2 className="font-serif text-3xl md:text-4xl leading-[1.1] text-foreground mb-5 max-w-[18ch]">
              {props.title}
            </h2>
          )}
          {props.body && (
            <p className="text-sm md:text-base text-foreground/75 font-light leading-relaxed whitespace-pre-line max-w-[44ch]">
              {props.body}
            </p>
          )}
          {props.cta_label && props.cta_url && (
            <a
              href={props.cta_url}
              className="inline-block mt-7 text-[11px] tracking-[0.3em] uppercase text-gold border-b border-gold/60 pb-1"
            >
              {props.cta_label}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
